var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectionCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.3904 1.33335C10.744 1.33343 11.0831 1.47395 11.3331 1.72402L13.6091 4.00002C13.8591 4.25001 13.9997 4.58909 13.9997 4.94268V10.6667C13.9997 11.0203 13.8593 11.3594 13.6092 11.6095C13.3592 11.8595 13.02 12 12.6664 12H11.3331V13.3333C11.3331 13.687 11.1926 14.0261 10.9425 14.2762C10.6925 14.5262 10.3534 14.6667 9.99974 14.6667H3.99974C3.64612 14.6667 3.30698 14.5262 3.05693 14.2762C2.80688 14.0261 2.66641 13.687 2.66641 13.3333V5.33335C2.66641 4.97973 2.80688 4.64059 3.05693 4.39054C3.30698 4.14049 3.64612 4.00002 3.99974 4.00002H5.33307V2.66668C5.33307 2.31306 5.47355 1.97392 5.7236 1.72387C5.97365 1.47383 6.31278 1.33335 6.66641 1.33335H10.3904ZM5.33307 5.33335H3.99974V13.3333H9.99974V12H6.66641C6.31278 12 5.97365 11.8595 5.7236 11.6095C5.47355 11.3594 5.33307 11.0203 5.33307 10.6667V5.33335ZM9.33307 2.66668H6.66641V10.6667H12.6664V6.00002H10.3331C10.0845 6 9.84481 5.9074 9.66079 5.74027C9.47678 5.57314 9.3616 5.34346 9.33774 5.09602L9.33307 5.00002V2.66668ZM10.6664 2.94268V4.66668H12.3904L10.6664 2.94268Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#464646"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionCopy);
export default __webpack_public_path__ + "static/media/selection-copy.2739f722d32c1f153646b3255bec7630.svg";
export { ForwardRef as ReactComponent };